import { Router } from "express";

import { classController } from "../controllers/class-controller";
import {
  authenticate,
  requireEmailVerification,
} from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";
import {
  attachSchoolContext,
  requireSchoolContext,
} from "../middleware/school-context-middleware";
import { uploadMiddleware } from "../middleware/upload-middleware";
import {
  assignTeacherValidation,
  createClassValidation,
  enrollStudentsValidation,
  updateClassValidation,
} from "../validation/school-validation";

const router = Router();

// Apply authentication and school context to all routes
router.use(authenticate);
router.use(requireEmailVerification);
router.use(requireRole(["school"]));
router.use(attachSchoolContext);
router.use(requireSchoolContext);

// School Admin Routes
router.post(
  "/",
  createClassValidation,
  classController.createClass.bind(classController),
);

router.get("/", classController.getAllClasses.bind(classController));

router.get("/:id", classController.getClassById.bind(classController));

router.put(
  "/:id",
  updateClassValidation,
  classController.updateClass.bind(classController),
);

router.delete("/:id", classController.deleteClass.bind(classController));

// Teacher Assignment Routes
router.post(
  "/:id/assign-teacher",
  assignTeacherValidation,
  classController.assignTeacher.bind(classController),
);

router.delete(
  "/:id/unassign-teacher",
  classController.unassignTeacher.bind(classController),
);

// Student Enrollment Routes
router.post(
  "/:id/enroll-students",
  enrollStudentsValidation,
  classController.enrollStudents.bind(classController),
);

router.delete(
  "/:id/unenroll-student/:studentId",
  classController.unenrollStudent.bind(classController),
);

router.get(
  "/:id/students",
  classController.getEnrolledStudents.bind(classController),
);

// Teacher Routes - View their classes
router.get(
  "/teacher/my-classes",
  classController.getTeacherClasses.bind(classController),
);

router.get(
  "/teacher/my-classes/:id",
  classController.getTeacherClassById.bind(classController),
);

router.get(
  "/teacher/my-classes/:id/students",
  classController.getTeacherClassStudents.bind(classController),
);

// School Data Routes
router.get(
  "/data/teachers",
  classController.getSchoolTeachers.bind(classController),
);

router.get(
  "/data/students",
  classController.getSchoolStudents.bind(classController),
);

// Semester-specific Routes
router.get(
  "/semester/:semesterId/classes",
  classController.getClassesBySemester.bind(classController),
);

// Class Materials Routes
router.post(
  "/:id/materials",
  uploadMiddleware.array("materials", 10),
  classController.addMaterials.bind(classController),
);

router.delete(
  "/:id/materials/:fileName",
  classController.removeMaterial.bind(classController),
);

// Class Schedule Routes
router.put(
  "/:id/schedule",
  classController.updateSchedule.bind(classController),
);

// Class Settings Routes
router.put(
  "/:id/settings",
  classController.updateSettings.bind(classController),
);

// Class Status Routes
router.put(
  "/:id/activate",
  classController.activateClass.bind(classController),
);

router.put(
  "/:id/deactivate",
  classController.deactivateClass.bind(classController),
);

router.put(
  "/:id/complete",
  classController.completeClass.bind(classController),
);

router.put("/:id/cancel", classController.cancelClass.bind(classController));

// Statistics Routes
router.get(
  "/statistics/overview",
  classController.getClassStatistics.bind(classController),
);

router.get(
  "/statistics/teacher/:teacherId",
  classController.getTeacherClassStatistics.bind(classController),
);

export { router as classRoutes };
